module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-rnd-intel.234fc26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-rnd-intel.png
// module id = bCUu
// module chunks = 0